/**
 * App-level container class shared across the navbar, the page's `<main>`,
 * and the footer so every top-level region of the app aligns on the same
 * horizontal axis at every viewport size.
 *
 * - `max-w-7xl` (1280px) caps the content column on large monitors.
 * - `mx-auto w-full` centers it within the viewport (or its parent).
 * - Horizontal padding scales responsively:
 *   - default (< 640px): `px-3` (12px)  — phones, maximize usable width
 *   - sm  (≥ 640px):     `px-4` (16px)  — small tablets
 *   - md  (≥ 768px):     `px-6` (24px)  — tablets / small laptops
 *   - lg  (≥ 1024px):    `px-8` (32px)  — desktops, more breathing room
 *
 * Components that need a full-bleed background (e.g. the sticky navbar bar,
 * a section with a colored background) should keep their outer wrapper
 * unconstrained and apply this class to their inner content slot.
 */
export const appContainerClass =
  "mx-auto w-full max-w-7xl px-3 sm:px-4 md:px-6 lg:px-8";
